import { defineComponent as _defineComponent } from 'vue'
import { Studio } from '@/modules/Studios/types'
import { getCurrentInstance } from 'vue'
import { useImage } from '@/shared/composables/image'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudioAboutTab',
  props: {
    studio: null
  },
  setup(__props: any) {

const { getAvatar } = useImage()


const instance = getCurrentInstance()

return { __sfc: true,getAvatar, instance }
}

})